<template>
  <v-sheet style="overflow: auto; position: relative;">
    <v-chip rounded="0" density="compact" style="position: absolute; right: 0; top: 0; z-index: 2000; height: 14px; font-size: 12px; border-radius: 0 0 0 20px !important;" variant="flat" color="black" v-if="tmp_selected.length > 0">ВЫБРАНО {{ tmp_selected.length }}</v-chip>

    <template v-for="specialist in specialists" :key="specialist">
      <v-card
          density="compact" elevation="0"
          rounded="0" draggable="true"
          class="specialist-card"
          v-on:click="toggle_selection(specialist)"
          v-on:dragend="end_dragging"
          v-on:dragstart="start_dragging(specialist)"
      >
        <template v-slot:prepend>
          <v-avatar :color="tmp_selected.includes(specialist.guid) ? 'green' : 'grey'" variant="tonal" size="40">
            <v-icon :icon="['fas', tmp_selected.includes(specialist.guid) ? 'check' : 'user']" />
          </v-avatar>
        </template>

        <template v-slot:title>
          <p style="font-size: 12px">{{ initials(specialist.name) }}</p>
        </template>

        <template v-slot:subtitle>
          <template v-for="(day, index) in specialist.days" :key="day" >
            <v-avatar v-if="hidden_weekends ? (index < 5) : true" :color="day ? 'green' : 'grey'" size="10" class="mr-1" />
          </template>
        </template>
      </v-card>
    </template>
  </v-sheet>
</template>

<script>
import { Specialists } from "@/store/wp_planner/specialists.store";
import { initials } from "../../../libs/utils";
import { CurrentElement, CurrentElement__Data, CurrentElement__Dst } from "@/store/wp_planner/events.store";
import { Reg_Documents } from "@/store/wp_planner/documents.store";
import { InfoBlock } from "@/store/wp_planner/info.store";
import { HideWeekends } from "@/store/wp_planner/settings.store";

export default {
  name: "Users__WP_Widget",
  data() {
    return {
      tmp_selected: []
    }
  },
  methods: {
    initials,
    toggle_selection: function (specialist) {
      if (!this.tmp_selected.includes(specialist.guid)) {
        this.tmp_selected.push(specialist.guid)
      } else {
        this.tmp_selected.splice(this.tmp_selected.findIndex(el => el === specialist.guid), 1)
      }
    },
    start_dragging: function (event_data) {
      this.event__dst = 'specialists'
      this.event__type = 'specialist'

      if (this.tmp_selected.length > 0) {
        this.event__data = this.tmp_selected
      } else {
        this.event__data = [event_data.guid]
      }
    },
    end_dragging: function () {
      event.preventDefault()
      this.event__type = null
      this.event__dst = null
      this.event__data = null
      this.tmp_selected = []
    },
    toggle_info: function (specialist) {
      this.info = specialist
    }
  },
  computed: {
    event__dst: {
      get() {
        return CurrentElement__Dst().get()
      },
      set(value) {
        CurrentElement__Dst().set(value)
      }
    },
    event__data: {
      get() {
        return CurrentElement__Data().get()
      },
      set(value) {
        CurrentElement__Data().set(value)
      }
    },
    event__type: {
      get() {
        return CurrentElement().get()
      },
      set(value) {
        CurrentElement().set(value)
      }
    },
    docs__registered: {
      get() {
        return Reg_Documents().get()
      },
      set(value) {
        Reg_Documents().set(value)
      }
    },
    info: {
      get() {
        return InfoBlock().get()
      },
      set(value) {
        InfoBlock().set(value)
      }
    },
    specialists: {
      get() {
        return Specialists().get()
      },
      set(value) {
        Specialists().set(value)
      }
    },
    hidden_weekends: {
      get() {
        return HideWeekends().get()
      },
      set(v) {
        HideWeekends().set(v)
      }
    },
  }
}
</script>

<style scoped>

</style>
